import * as React from 'react';

const useMaskScrollEffect = (ref: React.RefObject<HTMLElement>) => {
    const handleScroll = () => {
        if (ref.current.scrollHeight <= Math.ceil(ref.current.scrollTop + ref.current.offsetHeight)) {
            ref.current.style.webkitMaskImage = 'none';
        } else if (ref.current.scrollTop > 0 && ref.current.scrollTop < ref.current.scrollTop + ref.current.offsetHeight) {
            ref.current.style.webkitMaskImage = 'linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255) 30px, rgb(255, 255, 255) calc(100% - 30px), rgba(255, 255, 255, 0))';
        } else {
            ref.current.style.webkitMaskImage = 'linear-gradient(to top, transparent 0%, rgba(255, 255, 255, 1) 30px)';
        }
    };

    React.useEffect(() => {
        if (!ref || !ref.current) {
            return;
        }

        handleScroll();

        ref.current.addEventListener('scroll', handleScroll);

        return () => ref.current?.removeEventListener('scroll', handleScroll);
    });
};

export default useMaskScrollEffect;
